/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import GatewayGroupRoutes from './gateway-group.routes';
import AddGatewayGroupController from './add-gateway-group.controller';
import GatewayGroupDirective from './gateway-group.directive';
import GatewayGroupTableConfig from './gateway-group-table.config';

export default angular.module('tektelic.gatewayGroup', [])
    .config(GatewayGroupRoutes)
    .controller('AddGatewayGroupController', AddGatewayGroupController)
    .directive('tkGatewayGroup', GatewayGroupDirective)
    .factory('gatewayGroupTableConfig', GatewayGroupTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/gateway-group/index.js